import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../store/user/userActions';
import { useNavigate } from 'react-router-dom';
import logoImage from './../assets/images/logo.png';
import Form from 'react-bootstrap/Form';
import Loading from '../component/Laoding';
import { useSearchParams } from 'react-router-dom';





const Login = () =>{
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    // const reference = searchParams.get('Reference');
    // const process = searchParams.get('Process');
    const reference = searchParams.get('Reference') || '';
    const process = searchParams.get('Process') || 'Failed Payment';
    const [postCode, setPostCode] = useState('');
    const [referenceCode, setReferenceCode] = useState(reference);
    const [error, setError] = useState('');
    const loading = useSelector((state) => state.user.loading);


    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault(); 

        if (postCode === '' || referenceCode === '') {
            setError('Reference code and Post code are required.');
        } else {
            const userData = {
              postCode,
              referenceCode,
              process
            }
            dispatch(loginUser(userData, navigate))
        } 
    };
    // console.log(reference)
    return(<>
      {loading ? <Loading /> : null}
      <div className='login-mian-area'>
          <div className="login-container">
          <form onSubmit={handleSubmit} className="login-form">
            <img src={logoImage} alt='Logo' />
            <h2>Online Payment Portal</h2>
            <p>To verify your identity, please submit the below information</p>
            {error && <div className="error text-danger">{error}</div>}

            <Form.Group className="mb-3 text-start" controlId="ref">
              <Form.Label className=''>Risk Postcode</Form.Label> 
                        <Form.Control type="text" placeholder="Risk Postcode" value={postCode} onChange={(e) => setPostCode(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3 text-start" controlId="ref">
              <Form.Label className=''>Policy Reference</Form.Label> 
              <Form.Control type="text" placeholder="Policy Reference" value={referenceCode} onChange={(e) => setReferenceCode(e.target.value)} />
            </Form.Group>
    
            <button type="submit" className="btn btn-primary w-100 mt-3">Login</button>
          </form>
        </div>
      </div>
      </>)
}


export default Login;